import ApplicationController from './application_controller'

const THUMB_WIDTH = 23
const VALUES = ['100', '125', '150']

const THUMB_POSITIONS = {
  '100': '0px',
  '125': `calc(50% - ${THUMB_WIDTH / 2}px)`,
  '150': `calc(100% - ${THUMB_WIDTH}px)`
}

const FILL_WIDTHS = {
  '100': '0%',
  '125': '50%',
  '150': '100%'
}

export default class extends ApplicationController {
  static targets = ['thumb', 'fill', 'label', 'input', 'track']

  // Namespaced by quote ID to avoid cross-tab contamination when multiple quotes are open
  get _storageKey() {
    const quoteId = this.element.closest('[data-quote-id]')?.dataset.quoteId
    return `gaig_slider_pending_value_${quoteId || 'unknown'}`
  }

  connect() {
    super.connect()
    const pendingValue = sessionStorage.getItem(this._storageKey)
    if (pendingValue && VALUES.includes(pendingValue)) {
      sessionStorage.removeItem(this._storageKey)
      if (this.hasInputTarget) this.inputTarget.value = pendingValue
      this.updateUI(pendingValue)
    } else {
      const initialValue = this.hasInputTarget ? this.inputTarget.value : '100'
      // Guard against invalid values from the DB (e.g. 0). If the hidden input holds an
      // unsupported value, correct it in place so a form submission without touching the
      // slider doesn't hit the server-side InvalidAgreedValuePercentageError.
      const safeInitialValue = VALUES.includes(initialValue) ? initialValue : '100'
      if (this.hasInputTarget && safeInitialValue !== initialValue) this.inputTarget.value = safeInitialValue
      this.updateUI(safeInitialValue)
    }
  }

  select(event) {
    event.stopPropagation() // prevents selectFromTrack on the wrapper from also firing
    const value = event.currentTarget.dataset.value
    this.updateUI(value)
    if (this.hasInputTarget) {
      this.inputTarget.value = value
    }
    this._updatePercentIfGaigSelected(value)
    this._autoSelectGaigIfNeeded(value)
  }

  selectFromTrack(event) {
    event.stopPropagation()
    const rect = this.trackTarget.getBoundingClientRect()
    const pct = (event.clientX - rect.left) / rect.width

    let value
    if (pct < 0.33) {
      value = '100'
    } else if (pct < 0.66) {
      value = '125'
    } else {
      value = '150'
    }

    this.updateUI(value)
    if (this.hasInputTarget) {
      this.inputTarget.value = value
    }
    this._updatePercentIfGaigSelected(value)
    this._autoSelectGaigIfNeeded(value)
  }

  _updatePercentIfGaigSelected(value) {
    const gaigCard = document.getElementById('gaig-policy-card')
    if (!gaigCard || gaigCard.dataset.gaigSelected !== 'true') return

    const quoteId = this.element.dataset.agreedValueSliderQuoteId
    this.stimulate('QuoteFlowReflex#update_percent_of_agreed_value', quoteId, value)
  }

  _autoSelectGaigIfNeeded(value) {
    const gaigCard = document.getElementById('gaig-policy-card')
    if (gaigCard && gaigCard.dataset.gaigSelected === 'true') return

    sessionStorage.setItem(this._storageKey, value)
    this.element.dispatchEvent(new CustomEvent('agreed-value-slider:value-changed', { bubbles: true }))
  }

  updateUI(value) {
    const safeValue = VALUES.includes(value) ? value : '100'
    this.thumbTarget.style.left = THUMB_POSITIONS[safeValue]
    this.fillTarget.style.width = FILL_WIDTHS[safeValue]
    this.labelTargets.forEach(label => {
      const isSelected = label.dataset.value === safeValue
      label.style.fontWeight = isSelected ? '700' : '400'
    })
  }
}